import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Award } from "lucide-react";

const CERTS = Array.from({ length: 15 }, (_, i) => i + 1);

export const CertificatesModal = ({ open, onClose }) => {
    useEffect(() => {
        if (!open) return;
        document.body.style.overflow = "hidden";
        const onKey = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("keydown", onKey);
        };
    }, [open, onClose]);

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    data-testid="certificates-modal"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    onClick={onClose}
                    className="fixed inset-0 z-[60] flex items-center justify-center bg-miam-dark/60 p-4 backdrop-blur-sm"
                    role="dialog"
                    aria-modal="true"
                    aria-label="الشهادات والدورات"
                >
                    <motion.div
                        initial={{ opacity: 0, y: 32, scale: 0.97 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 24, scale: 0.97 }}
                        transition={{ duration: 0.35, ease: "easeOut" }}
                        onClick={(e) => e.stopPropagation()}
                        className="max-h-[85vh] w-full max-w-5xl overflow-y-auto rounded-3xl bg-miam-cream p-6 soft-shadow lg:p-10"
                    >
                        <div className="mb-8 flex items-center justify-between gap-4">
                            <h2 className="flex items-center gap-3 font-heading text-2xl font-bold text-miam-dark lg:text-3xl">
                                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-miam-green/12 text-miam-green-dark">
                                    <Award className="h-5 w-5" aria-hidden="true" />
                                </span>
                                الشهادات والدورات
                            </h2>
                            <button
                                type="button"
                                onClick={onClose}
                                data-testid="certificates-modal-close"
                                aria-label="إغلاق"
                                className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-miam-dark transition-colors duration-300 hover:bg-miam-rose hover:text-white"
                            >
                                <X className="h-5 w-5" aria-hidden="true" />
                            </button>
                        </div>

                        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                            {CERTS.map((n, i) => (
                                <a
                                    key={n}
                                    href={`/certs/cert-${String(n).padStart(2, "0")}.jpg`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`certificate-link-${i}`}
                                    aria-label={`شهادة مهنية ${n} – افتحي بالحجم الكامل`}
                                    className="block overflow-hidden rounded-2xl bg-white p-2 soft-shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:soft-shadow"
                                >
                                    <img
                                        src={`/certs/cert-${String(n).padStart(2, "0")}.jpg`}
                                        alt={`شهادة مهنية لمياسة رقم ${n}`}
                                        data-testid={`certificate-image-${i}`}
                                        loading="lazy"
                                        className="aspect-[3/4] w-full rounded-xl object-contain"
                                    />
                                </a>
                            ))}
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
